import { z } from 'zod';
export const customerPropertyRelationSchema = z.enum(['Owner', 'Tenant', 'Unknown']);
export const CustomerPropertyRelation = customerPropertyRelationSchema.enum;
export const customerProvidesMaterialSchema = z.enum(['Yes', 'No', 'Unknown']);
export const CustomerProvidesMaterial = customerProvidesMaterialSchema.enum;
